import { render, staticRenderFns } from "./editcompanyacname.vue?vue&type=template&id=5b7e9722&scoped=true&"
import script from "./editcompanyacname.vue?vue&type=script&lang=ts&"
export * from "./editcompanyacname.vue?vue&type=script&lang=ts&"
import style0 from "./editcompanyacname.vue?vue&type=style&index=0&id=5b7e9722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e9722",
  null
  
)

export default component.exports